<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-bottom:-5px; margin-left:10px">
      <div class="flex-row flex">
        <h4 class="title">{{lblHeading}}</h4>
      </div>
      <h6 *ngIf="routeCtrl.isNew">
        <span style="padding-right:5px"></span>
        <i class="fa fa-globe"></i>
        <b>Route </b> <span style="color:lightgray">
          <a class="red-asterik">*</a> Please complete all required fields needed to create your route
        </span>
      </h6>
    </div>
  </div>
  <hr>
  <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
    <div class="row">
    <div class="col-md-3">
      <div class=" form-group ">
        <!--New Tabs-->

          <ul class="nav nav-tabs" id="route-tabs" role="tablist">
            <li class="nav-item waves-effect waves-light ">
              <a class="nav-link active"  data-toggle="tab" href="#desc" role="tab" aria-controls="desc" aria-selected="true"><h6>Details</h6></a>
            </li>
            <li class="nav-item waves-effect waves-light">
              <a class="nav-link " data-toggle="tab" href="#bord" role="tab" aria-controls="bord" aria-selected="false" ><h6>Route</h6></a>
            </li>
          </ul>
          <div class="tab-content" id="borderTabContent" style="margin:4px!important;padding:4px!important;">
            <div class="tab-pane fade in active" id="desc" role="tabpanel" aria-labelledby="desc-tab">
                <div class="col-sm-12 p-0 mt-2">
                  <!-- <label for="description" class="label-desc">Route Details (You can edit route details if necessary)<span *ngIf="isRequired" class="red-asterik">*</span></label>
                  <p class="label-route">
                    Enter a detailed description of the whole route, indicating all the stopping points and
                    border posts
                  </p> -->
                  <!-- <div class="row">
                    <div class="col-sm-12 "  style="display: none;">
                      <input type="hidden" formControlName="id" />
                      <label>Code<span *ngIf="isCodeDup" class="text-danger"> Code already in use</span></label>
                      <input formControlName="code" maxlength="20"
                             title="Enter a unique identifier for this route (e.g. HREJHB01)" name="code"
                             class="form-control form-control-sm" type="text" readonly
                             [ngClass]="{'error':form.controls.code.invalid && form.controls.code.dirty, 'noerror': form.controls.code.valid && form.controls.code.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                        <p *ngIf="form.controls.code.errors.required">Code is required</p>
                      </div>
                    </div>
                    
                    <div class="col-sm-4">
                      <label>Type</label>
                      <select formControlName="route_type_ind" class="form-control form-control-sm" type="text" (change)="isWithLegs()"
                              title="Select the route type to be used" *ngIf="!routeCtrl.isNew">
                        <option value="1">Standard descriptive</option>
                        <option value="3">Standard with legs/places</option>
                        <option value="5">Standard desc & legs</option>
                        <option value="11">Carrier-defined descriptive</option>
                        <option value="13">Carrier-defined with legs/places</option>
                        <option value="15">Carrier-defined desc & legs</option>
                      </select>
                      <select formControlName="route_type_ind" class="form-control form-control-sm" type="text" (change)="isWithLegs()"
                              title="Select the route type to be used" *ngIf="routeCtrl.isNew">
                        <option value="13">Carrier-defined with legs/places</option>
                        <option value="15" [selected]="true">Carrier-defined desc & legs</option>
                      </select>
                    </div> 
                  </div>-->
                  <div class="row">
                    <div class="col-md-12 " [ngClass]="{'disabled': isFreight}">
                      <div class="control-label ">Route Name<a class="red-asterik">*</a></div>
                      <input formControlName="description" name="description"
                             title="Enter a name for the route that is easy to remember (e.g. Harare to Joburg)"
                             class="form-control form-control-sm" type="text"
                             [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}" />
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.description.invalid && form.controls.description.dirty">
                        <p *ngIf="form.controls.description.errors.required">Route Name is required</p>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 " [ngClass]="{'disabled': isFreight}">
                      <div class="control-label " style="margin-top: 5px;">Description<a class="red-asterik">*</a></div>
                      <textarea formControlName="route_summary" style="height: 100px;" name="route_summary"
                                title="Enter a short description of the route (e.g. Harare to Joburg via Bulawayo)"
                                class="form-control form-control-sm" type="text"
                                [ngClass]="{'error':form.controls.route_summary.invalid && form.controls.route_summary.dirty, 'noerror': form.controls.route_summary.valid && form.controls.route_summary.dirty}"></textarea>
                      <div class="form-control-feedback text-danger text-small"
                           *ngIf="form.controls.route_summary.invalid && form.controls.route_summary.dirty">
                        <p *ngIf="form.controls.route_summary.errors.required">Description is required</p>
                      </div>
                    </div>
                  </div>
                  <div class="row"  *ngIf="!isExternalRole">
                    <div class="col-md-12 ">
                      <div class="control-label "  style="margin-top: 5px;margin-bottom: 5px;">Permit Type</div>
                        <select class="form-control form-control-sm" name="freight_passenger_ind" formControlName="freight_passenger_ind" (change)="onItemChange()">
                        <option value="" selected class="text-muted">Choose a Permit type</option>
                        <option value="1">Freight</option>
                        <option value="2">Passenger</option>
                        <!-- <option value="3">Both</option> -->
                        </select>
                    </div>
                </div>

                  <div class="row"  *ngIf="routeLeg?.route_type_ind === 1 || routeLeg?.route_type_ind ===11">
                    <div class="col-md-12 ">
                      <div class="control-label "  style="margin-top: 5px;margin-bottom: 5px;">Route Details</div>
                      <quill-editor [styles]="{height: '320px'}" name="route_detail"    formControlName="route_detail"
                                    [modules]="quillConfig">
                      </quill-editor>
                    </div>
                </div>
                  <!-- <div class="row">
                    <div class="col-md-12 ">
                      <div class="control-label "  style="margin-top: 5px;margin-bottom: 5px;">Transport Association</div>
                        <select class="form-control form-control-sm" [attr.disabled]="form.value['freight_passenger_ind']=='1' ? true : null" name="assoc_id" formControlName="assoc_id" (change)="onItemChange()">
                        <option value="" selected class="text-muted">{{trspassoc}}</option>
                        <ng-container *ngFor="let assoc of listAssoc">
                        <option *ngIf="assoc.is_active" [ngValue]="assoc.id">{{assoc.desc}}</option>
                        </ng-container>
                        </select>
                    </div>
                </div> -->
                <div>
                  <div class="row"  *ngIf="!isExternalRole">
                  <div class="col-md-12 ">
                    <div class="control-label"  style="margin-top: 5px;margin-bottom: 5px;">Transport Association</div>
                      <ng-multiselect-dropdown  [placeholder]="'Select one or more associations...'"
                               [data]="associations"
                               formControlName="selectedItems"
                               [settings]="dropdownSettings"
                               (onSelect)="onItemSelect($event)"
                               (onDeSelect)="onDeSelect($event)"
                               (onSelectAll)="onSelectAll($event)"
                               (onDeSelectAll)="onDeSelectAll($event)">
                      </ng-multiselect-dropdown>
                    </div>
                  </div>
                </div>

                  <!-- <ckeditor title="" formControlName="route_detail" debounce="500">
                  </ckeditor> -->
                </div>
              </div>
              <div class="tab-pane fade " id="bord" role="tabpanel" aria-labelledby="bord-tab"  >
                <div class="row" style="margin:20px auto!important;">
                  <div class="col-12">
                    <table class="table table-sm table-borderless">
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="row rm-mp">
                            <div class="col-12 rm-mp" style="height:20px!important;">
                              <i class="fa fa-circle-o fa-cx" aria-hidden="true" style="margin-left:-8px!important;padding-left:-8px!important;"></i>&nbsp;Departure
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="row rm-mp" [ngClass]="{'disabled':isActing()}">
                            <div class="col-6 rm-mp vLine">
                              <select #departureCountryRef formControlName="departure_country_id"
                                      (change)="departureCountryChange(departureCountryRef.value)" class="form-control form-control-md"
                                      type="text"
                                      [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}">
                                <option *ngFor="let country of countries" [selected]="country.id == selectedDepartureCountry"
                                        [value]="country.id">
                                  {{country.desc}}
                                </option>
                              </select>
                            </div>
                            <div class="col-6">
                              <input type="hidden" formControlName="first_place_leg_id" />
                              <select #departurePlaceRef formControlName="departure_place_id" class="form-control form-control-md" type="text" (change)="departurePlaceChange(departurePlaceRef.value)"
                                      [ngClass]="{'error':form.controls.description.invalid && form.controls.description.dirty, 'noerror': form.controls.description.valid && form.controls.description.dirty}">
                                <!-- <option *ngFor="let place of departurePlaces" [value]="place.id" [selected]="place.id==''" [disabled]="place.id==''">
                                  {{place.name}}
                                </option> -->
                                <option >Select a place</option>
                                <ng-container *ngFor="let place of departurePlaces">                                  
                                  <option *ngIf="place.is_active" [value]="place.id" [selected]="place.id==''" [disabled]="place.id==''">{{place.name}}</option>
                                </ng-container>
                              </select>
                            </div>
                           
                          </div>
                        </td>
                      </tr>
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="col-12 rm-mp vLine" formArrayName="borderCrossings"
                               *ngFor="let item of form.get('borderCrossings').controls; let i = index;">

                            <div [formGroupName]="i">

                              <div class="row rm-mp" *ngIf="isBorder(i)">
                                <div class="col-12 rm-mp">
                                  <i class="fa fa-circle fa-cx" aria-hidden="true" style="margin-left:-9px!important;padding-left:-9px!important;"></i>&nbsp;{{isStop(i)?'Stop(s)' : 'Border crossing(s)'}}
                                </div>
                              </div>

                              <div class="row" [ngClass]="{'disabled':i<selectedBorderCrossings.length-1}">
                                <div class="col-6">
                                  <input type="hidden" formControlName="legId" />
                                  <input type="hidden" formControlName="placeTo" />
                                  <input type="hidden" formControlName="stepNum" />
                                  <input type="hidden" formControlName="routeType" />
                                  <input *ngIf="!isStop(i)" type="text" [value]="selectedBorderCrossings[i]?.CountryFName||'Choose a border crossing or remove this row*'" class="form-control form-control-md text-primary" [ngClass]="{'f-sz':!isMessage(i)}" />
                                  <input *ngIf="isStop(i)" type="text" [value]="selectedBorderCrossings[i]?.CountryFName||'Choose a stop and a stop type or remove this row*'" class="form-control form-control-md text-primary" [ngClass]="{'f-sz':!isMessage(i)}" />
                                </div>
                                
                              </div>
                              <div class="row" [ngClass]="{'disabled':isFreight}">
                                <div class="col-6">
                                  <select #refBorder formControlName="placeFrom" class="form-control form-control-md" (change)="onBorderCrossingChange(refBorder.value,i)">
                                    <option *ngFor="let place of borderPlaces[i]" [value]="place.PlaceId">
                                      {{place.PlaceName}}
                                    </option>
                                  </select>
                                </div>
                                <div class="col-4">
                                  <input *ngIf="!isStop(i)" type="text" [value]="selectedBorderCrossings[i]?.CountrySName" class="form-control form-control-md text-success" />
                                  <select *ngIf="isStop(i)" class="form-control form-control-md" id="stopType" name="stopType" formControlName="stopType">
                                    <option *ngFor="let sType of utility.listStops" [value]="sType.key">{{sType.value}}</option>
                                  </select>
                                </div>
                                <div class="col-2">
                                  <div *ngIf="i==this.borderCrossings.length-1" title="Remove border crossing" style="margin-bottom:5px!important;margin-left:2px!important;" class="rmvbc rounded-circle pull-right" (click)="onRemoveItem(i)"></div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="row rm-mp">
                            <div class="col-12 rm-mp">
                              <i class="fa fa-map-marker fa-mx" aria-hidden="true" style="margin-left:-7px!important;padding-left:-8px!important;"></i>&nbsp;Destination
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="row rm-mp" [ngClass]="{'disabled':!isActing() || isFreight}">
                            <div class="col-6 rm-mp vLine">

                              <input type="text" [value]="selectedDestinationCountry || selectedDepartureCountry" class="form-control form-control-md" />
                              <input type="hidden" formControlName="destination_country_id" [ngModel]="destinationId" />
                            </div>
                            <div class="col-6">
                              <select formControlName="destination_place_id" class="form-control form-control-md" type="text"
                              #destinationPlaceRef (change)="destinationPlaceChange(destinationPlaceRef.value)">

                                <!-- <option *ngFor="let place of destinationPlaces" [value]="place.id" [selected]="(routeLeg?.destination_place_id)?place.id==routeLeg?.destination_place_id:place.id==''" [disabled]="(routeLeg?.destination_place_id)?place.id==routeLeg?.destination_place_id:place.id==''">
                                  {{place.name}}
                                </option> -->
                                <ng-container *ngFor="let place of destinationPlaces">
                                  <option *ngIf="place.is_active ==true" [value]="place.id" [selected]="(routeLeg?.destination_place_id)?place.id==routeLeg?.destination_place_id:place.id==''" [disabled]="(routeLeg?.destination_place_id)?place.id==routeLeg?.destination_place_id:place.id==''">{{place.name}}</option>
                                </ng-container>

                              </select>
                            </div>
                           
                          </div>
                        </td>
                      </tr>
                      <tr class="rm-mp">
                        <td class="rm-mp">
                          <div class="row rm-mp">
                            <div class="col-12 rm-mp" [ngClass]="{'disabled':isAddModel || isFreight}">
                              <i class="fa fa-plus-circle fa-cx" aria-hidden="true" style="margin-left:-8px!important;padding-left:-8px!important;"></i>
                              <label style="font-weight:normal!important;font-size:13px!important;margin-bottom:4px!important;" (click)="addItem(1)" class="text-secondary btn-link rm-mp">
                                Add a border crossing
                              </label>&nbsp;&nbsp;
                              <i class="fa fa-plus-circle fa-cx" aria-hidden="true" style="margin-left:-8px!important;padding-left:-8px!important;"></i>
                              <label style="font-weight:normal!important;font-size:13px!important;margin-bottom:4px!important;" (click)="addItem(2)" class="text-secondary btn-link rm-mp">
                                Add a stop
                              </label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <div class="card" [ngClass]="{showCard:ShowMyPanel === true , hideCard:ShowMyPanel === false}">
                          <h6 class="title">Directions</h6>
                            <div #myPanel  [ngClass]="{DirectionPanel:ShowMyPanel === true}"></div>
                        </div>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
        <div class="row">


        </div>
        <!--End Tabs-->
        <!--</fieldset>-->

        <!-- <br>
        <fieldset class="scheduler-border" style="margin-bottom: 8px !important; padding:0px;" *ngIf="!routeCtrl.isNew">
          <legend class="scheduler-border tsk-display"><b>Sorting And Displaying</b></legend>
          <div class="row">
            <div class="col-3">
              <label>Sort order<a class="red-asterik">*</a></label>
              <select id="sort_order" class="form-control form-control-sm" name="sort_order" formControlName="sort_order"
                      style="width:100%;"
                      title="Allows user to put in a sorting code. By default, all rows will have sort_order 1.">
                <option *ngFor="let rank of utility.sortOrderList" [selected]="0" [ngValue]="rank">{{rank}}</option>
              </select>
            </div>
            <div class="col-3">
              <label>Group Code<a class="red-asterik">*</a></label>
              <input formControlName="group_code" maxlength="12" name="group_code" class="form-control form-control-sm"
                     title="Allows user to group codes. By default, all rows will belong to group A." type="text"
                     [ngClass]="{'error':form.controls.group_code.invalid && form.controls.group_code.dirty, 'noerror': form.controls.group_code.valid && form.controls.group_code.dirty}" />
              <div class="form-control-feedback text-danger text-small"
                   *ngIf="form.controls.group_code.invalid && form.controls.group_code.dirty">
                <p *ngIf="form.controls.group_code.errors.required">Group Code is required</p>
              </div>
            </div>
            <div class="col-3">
              <label>Display When?<a class="red-asterik">*</a></label>
              <select class="form-control form-control-sm" id="display_ind" [(ngModel)]="selectedDisplay" (change)="onSelectChange()"
                      name="display_ind" formControlName="display_ind"
                      title="Indicates where it is used on dropdowns or lists.">
                <option *ngFor="let ind of utility.displayIndicators" [selected]="0" [ngValue]="ind.key">
                  {{ind.value}}
                </option>
              </select>
            </div>
            <div class="col-2"></div>
            <div class="col-1 text-right">
              <label class="">Active?</label>
              <input formControlName="is_active"  (change)="checkValidity($event)" type="checkbox" class="form-control form-control-sm pull-right" style="margin-right:8px!important;" />
            </div>
          </div>
        </fieldset>
        <div *ngIf="routeCtrl.isNew">
          <input type="hidden" formControlName="sort_order" />
          <input type="hidden" formControlName="group_code" />
          <input type="hidden" formControlName="display_ind" [(ngModel)]="selectedDisplay" />
          <input type="hidden" formControlName="is_active" />
        </div> -->
      </div>
      <div class="col-12 text-center" *ngIf="isExternalRole">

        <button title="Add your route to your permit application" type="button" id="addApplication" [disabled]="!form.valid"
                class="btn  hd-btn"  (click)="updateApplicationRoute(form.value)">Add Route to Application</button>
        <br/>
        <br/>
        <button title="Add your route to your permit application" type="button" id="cancel"
                class="btn hd-btn-close"  (click)="back()">Back to Application</button>
      </div>
      <br/>
      <br/>
      <br/>
    </div>

    <div class="col-md-9" style="margin:0px;padding:0px;padding-right: 45px;">
      <agm-map [latitude]="lat" [longitude]="lng" draggableCursor="default" draggingCursor="default" >
        <agm-direction [origin]="origin" [waypoints]="waypoints" [destination]="destination" [panel]="myPanel">
          </agm-direction>
      </agm-map>
      
    </div>
  </div>

    <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;" *ngIf="!isExternalRole">
      <dl style="width:460px;margin:0px;padding:0px;">
        <dt style="width:40px;">Created</dt>
        <dd [innerHTML]="audit.created"></dd>
        <dt style="width:46px;">Updated</dt>
        <dd [innerHTML]="audit.updated"></dd>
      </dl>
      <hr>
    </div>
    <div class="col-12" *ngIf="!isExternalRole">
      <br>
      <button *ngIf="!routeCtrl.isNew" title="Save change(s)" type="submit" id="btnSave" 
              class="btn hd-btn pull-right" style="width:10%; margin-left:10px;color:white;background-color:#1d3f94!important">
        <!-- <i class="fa fa-save"></i> -->
        Save
      </button>
      <button *ngIf="routeCtrl.isNew" title="Add your route to your permit application" type="button" id="btnSave" [disabled]="!form.valid"
              class="btn btn-md pull-right" style="width:10%; margin-left:10px;color:white;background-color:#1d3f94" (click)="addPermitRoute(form.value)">
        <!--<i class="fa fa-save"></i>-->
        <!-- <i class="fa fa-plus"></i> -->
        Add route
      </button>
      <button title="Go Back" type="button" id="btnCancel" (click)="backPage()"
              class="btn hd-btn-close pull-right" style="width:10%; margin-left:10px;color:white;background-color:#1d3f94">
        <!-- <i class="fa fa-arrow-circle-left"></i> -->
        Back
      </button>
    </div>
  </form>
</div>


<button data-toggle="modal" data-target="#editPlace" id="secretModalButton" style="display:none"></button>

<div class="modal fade" id="editPlace" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document" style="width: 100% !important;max-width: 1400px;">
      <div class="modal-content">
          <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Geo-Locate a Place</h5>
              <button type="button" id="closeEditPlaceModal" (click)="closePlaceModal()" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>
          <div class="modal-body">
              <div class="clearfix section  pb-8 text-gray">
                  <app-add-new-place [place]="selectedPlaceId"></app-add-new-place>
              </div>
          </div>
          
      </div>
  </div>


</div>